<template>
    <div class="px-4 border-theme-border border-b pb-4 rounded-md">
        <div>
            <span class="text-lg text-center block my-4">{{ title }}</span>

            <div class="bg-theme-card gap-2 flex rounded-md">
                <button
                    :class="[
                        'border-2 border-brand-blue rounded-lg flex-1 py-4',
                        { 'bg-brand-blue text-white': mode === 'relative' }
                    ]"
                    @click="switchMode('relative')"
                >
                    <span class="icon">⏱️</span>
                    <span class="label">Relativas</span>
                </button>
                <button
                    :class="[
                        'border-2 border-brand-blue rounded-lg flex-1 py-4',
                        {
                            'bg-brand-blue text-white': mode === 'absolute'
                        }
                    ]"
                    @click="switchMode('absolute')"
                >
                    <span class="icon">📅</span>
                    <span class="label">Absolutas</span>
                </button>
            </div>
        </div>

        <div class="filter-content mt-2">
            <transition name="fade" mode="out-in">
                <relative-date-picker
                    v-if="mode === 'relative'"
                    key="relative"
                    v-model="dateRange"
                    :allow-future-dates="allowFutureDates"
                    @change="handleChange"
                />
                <date-range-picker
                    v-else
                    key="absolute"
                    v-model="dateRange"
                    :allow-future-dates="allowFutureDates"
                    @change="handleChange"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import DateRangePicker from "./DateRangePicker.vue";
import RelativeDatePicker from "./RelativeDatePicker.vue";

export default {
    name: "DatesFilter",
    components: {
        DateRangePicker,
        RelativeDatePicker
    },
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        title: {
            type: String,
            default: "Filtro de fechas"
        },
        allowFutureDates: {
            type: Boolean,
            default: false
        },
        defaultMode: {
            type: String,
            default: "relative",
            validator: (value) => ["relative", "absolute"].includes(value)
        }
    },
    data() {
        return {
            mode: this.defaultMode,
            dateRange: {}
        };
    },
    watch: {
        value: {
            handler(newValue) {
                if (newValue && Object.keys(newValue).length > 0) {
                    this.dateRange = { ...newValue };
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        switchMode(newMode) {
            if (this.mode !== newMode) {
                this.mode = newMode;
            }
        },
        handleChange(value) {
            this.$emit("change", value);
        }
    }
};
</script>
